// Sign out and leave the console. /logout clears the isi_token cookie,
// revokes the Kratos session, and hands back the login_url to land on.
import axios from "axios";
import { ISI_API_URL } from "@/config";
import { appendLangParam } from "@/i18n";

export async function logoutAndLeave() {
  let loginUrl = null;
  try {
    const res = await axios.get(ISI_API_URL + "logout", {
      withCredentials: true,
    });
    loginUrl = res.data && res.data.login_url;
  } catch (err) {
    // fall through: still leave the app
  }
  window.location.href = appendLangParam(loginUrl) || "/";
}
